var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white charts-canvas",staticStyle:{"height":"500px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }